import { PassingTime } from '@/features/trips/PassingTime';
import { RiderTypes } from '@/features/shared/models/RiderType';
import { StopTotalsWithSum } from './Stop';

function map(totals: { [key: string]: number }) {
    const carTypes = [
        RiderTypes.Cars,
        RiderTypes.Cars8m,
        RiderTypes.Cars10m,
        RiderTypes.Cars12m,
        RiderTypes.Cars14m,
        RiderTypes.Cars17m,
        RiderTypes.Cars19m,
        RiderTypes.Cars22m,
        RiderTypes.CarsMin22m,
        RiderTypes.Motorcycles
    ];

    const result: StopTotalsWithSum = {
        passengers: totals[RiderTypes.Passengers],
        cars: totals[RiderTypes.Cars],
        cars8m: totals[RiderTypes.Cars8m],
        cars10m: totals[RiderTypes.Cars10m],
        cars12m: totals[RiderTypes.Cars12m],
        cars14m: totals[RiderTypes.Cars14m],
        cars17m: totals[RiderTypes.Cars17m],
        cars19m: totals[RiderTypes.Cars19m],
        cars22m: totals[RiderTypes.Cars22m],
        carsMin22m: totals[RiderTypes.CarsMin22m],
        mc: totals[RiderTypes.Motorcycles]
    };

    // only include cars if we have them
    if (Object.keys(totals).filter(x => x !== RiderTypes.Passengers).length > 0) {
        // combine all car types
        result.allCars = Object.keys(totals).reduce((acc, curr) => {
            if (carTypes.indexOf(curr) === -1) return acc;
            return acc + totals[curr];
        }, 0);
    }

    return result;
}

function getTotalsOnboard(passingTimes: PassingTime[]): { [key: string]: number } {
    if (!passingTimes || passingTimes.length === 0) return null;

    return passingTimes.reduce((acc, curr) => {
        const { stopEventData } = curr;
        if (!stopEventData) return acc;

        for (const key in stopEventData) {
            if (!acc[key]) acc[key] = 0;
            acc[key] += stopEventData[key].in - stopEventData[key].out;
        }

        return acc;
    }, {});
}

function getTotals(passingTimes: PassingTime[]): { [key: string]: number } {
    if (!passingTimes || passingTimes.length === 0) return null;

    return passingTimes.reduce((acc, curr) => {
        const { stopEventData } = curr;
        if (!stopEventData) return acc;

        for (const key in stopEventData) {
            if (!acc[key]) acc[key] = 0;
            acc[key] += stopEventData[key].in;
        }

        return acc;
    }, {});
}

export function getPassingTimeTotalsOnboardForStop(passingTimes: PassingTime[], passingTime: PassingTime): StopTotalsWithSum {
    const quayRef = passingTime.stop.quayRef;
    const time = passingTime.passingTime;

    if (!passingTimes || passingTimes.length === 0 || !quayRef) return null;

    const passingTimeIndex = passingTimes.findIndex(x => x.stop.quayRef === quayRef && x.passingTime == time);
    if (passingTimeIndex === -1) return null;

    return map(getTotalsOnboard(passingTimes.slice(0, passingTimeIndex + 1)));
}

export function getPassingTimeTotalsOnboard(passingTimes: PassingTime[]): StopTotalsWithSum {
    return map(getTotalsOnboard(passingTimes));
}

export function getPassingTimeTotals(passingTimes: PassingTime[]): StopTotalsWithSum {
    return map(getTotals(passingTimes));
}

export function hasNegativeOnboard(totals: StopTotalsWithSum): boolean {
    if (!totals) return false;
    if (totals.passengers < 0) return true;
    return typeof totals.allCars === 'number' && totals.allCars < 0;
}
